// importing actions
import {START_FETCH_MEDIA_LIST, SUCCESS_FETCH_MEDIA_LIST, FAILED_FETCH_MEDIA_LIST} from './actions/getMediaList'
import {START_DELETE_MEDIA, SUCCESS_DELETE_MEDIA, FAILED_DELETE_MEDIA} from './actions/deleteMedia'

export const DEFAULT_PAGINATION = {
  activePage: 1,
  itemsCountPerPage: 12,
  totalItemsCount: 0,
}

const initState = {
  list: [],
  pagination: DEFAULT_PAGINATION,
}

export default function MediaCenter(state = initState, action){
  switch(action.type){

    // Fetching
    case START_FETCH_MEDIA_LIST: {
      return {...state, ...action.payload}
    }
    case SUCCESS_FETCH_MEDIA_LIST: {
      const {
        data_list,
        total_count,
        fetching,
        hasPermission,
        amount_per_page,
        current_page_number,
        page_amount
      } = action.payload

      return {
        ...state,
        list: data_list,
        count: total_count,
        fetching,
        hasPermission,
        pagination: {
          itemsCountPerPage: amount_per_page,
          activePage: current_page_number,
          totalItemsCount: total_count,
        }
      }
    }
    case FAILED_FETCH_MEDIA_LIST: {
      const {error, fetching, hasPermission} = action.payload
      return {...state, error, hasPermission, fetching}
    }

    // Deleting
    case START_DELETE_MEDIA: {
      const { index } = action.payload;

      return {
        ...state,
      }
    }


    default: return {...state}
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/MediaCenter/redux/reducer.js